import * as React from 'react';
import { Star } from 'lucide-react';
import { cn } from '../../utils';

export type StarRatingProps = {
  value: number;
  onChange: (value: number) => void;
  max?: number;
  size?: number;
  disabled?: boolean;
  className?: string;
};

export function StarRating({
  value,
  onChange,
  max = 5,
  size = 28,
  disabled = false,
  className,
}: StarRatingProps) {
  const [hoverValue, setHoverValue] = React.useState(0);

  return (
    <div
      className={cn('inline-flex items-center gap-1', className)}
      onMouseLeave={() => setHoverValue(0)}
    >
      {Array.from({ length: max }, (_, i) => {
        const starValue = i + 1;
        const isFilled = starValue <= (hoverValue || value);

        return (
          <button
            key={starValue}
            type="button"
            disabled={disabled}
            className={cn(
              'rounded-sm p-0.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
            )}
            onMouseEnter={() => !disabled && setHoverValue(starValue)}
            onClick={() => !disabled && onChange(starValue)}
            aria-label={`${starValue} star${starValue !== 1 ? 's' : ''}`}
          >
            <Star
              size={size}
              className={cn(
                'transition-colors',
                isFilled
                  ? 'fill-yellow-400 text-yellow-400'
                  : 'fill-transparent text-muted-foreground/40',
              )}
            />
          </button>
        );
      })}
    </div>
  );
}
